import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Pixels',
    description:
        'A subscription library of premium, motion-first web sections. Few, but flawless.',
    url: getOrigin()
}

export const contactDetails = {
    email: 'studio@pixels.build',
    reply: 'Within one working day',
    location: 'Remote — CET / GMT+1',
    hours: 'Mon to Fri, 09:00 – 18:00'
}
